import { PromotionStoreType } from '@/types/storeTypes/promotionStoreTypes'
import { StateCreatorType } from '@/types/storeTypes/storeType'

const promotionStore: StateCreatorType<PromotionStoreType> = (set) => ({
  offers: null,
  currentOfferId: '',
  promotionData: null,
  hasPromotion: undefined,
  loading: false,
  error: false,

  setOffers: (offers) =>
    set(
      (state) => {
        state.promotion.offers = offers
      },
      false,
      'setOffers',
    ),
  setCurrentOfferId: (currentOfferId) =>
    set(
      (state) => {
        state.promotion.currentOfferId = currentOfferId
      },
      false,
      'setCurrentOfferId',
    ),
  setHasPromotion: (hasPromotion) =>
    set(
      (state) => {
        state.promotion.hasPromotion = hasPromotion
      },
      false,
      'setHasPromotion',
    ),
  setPromotionData: (promotionData) =>
    set(
      (state) => {
        state.promotion.promotionData = promotionData
      },
      false,
      'setPromotionData',
    ),
  setError: (error) =>
    set(
      (state) => {
        state.promotion.error = error
      },
      false,
      'setError',
    ),
  setLoading: (loading) =>
    set(
      (state) => {
        state.promotion.loading = loading
      },
      false,
      'setLoading',
    ),
})

export default promotionStore
